// extracted by mini-css-extract-plugin
export default {"congratsContainer":"CompletedStateArticle_congratsContainer__8+9Si","reward":"CompletedStateArticle_reward__KxweF","badgeIcon":"CompletedStateArticle_badgeIcon__hMsEC"};